import { EventLabel } from "shared/components/EventLabel";
import { SrcSet } from "shared/components/SrcSet";
import { formatDatePreview } from "shared/utils/formatDate";
import { useRouter } from "next/router";
import styles from "./EventList.module.css";
import { useAppContext } from "shared/utils/useAppContext";

const sortByKey = (obj) =>
  Object.keys(obj)
    .sort()
    .reduce(function (result, key) {
      if (typeof obj[key] === "object" && !Array.isArray(obj[key]))
        obj[key] = sortByKey(obj[key]);
      result[key] = obj[key];
      return result;
    }, {});

export const EventList = ({ items }) => {
  const { locale } = useRouter();
  const { createInternalHref } = useAppContext();

  const sorted = sortByKey(
    items.reduce((sorted, event) => {
      const date = new Date(event.date);
      const year = date.getFullYear();
      const month = date.getMonth();
      if (!sorted[year]) sorted[year] = {};
      if (!sorted[year][month])
        sorted[year][month] = {
          label: date.toLocaleString("en-US", { month: "long" }),
          items: [],
        };
      sorted[year][month].items.push(event);
      return sorted;
    }, {})
  );

  return (
    <div className={styles.container}>
      {Object.entries(sorted).map(([year, months]) =>
        Object.entries(months).map(([month, data]) => (
          <div className={styles.month} key={month}>
            <h2 className={styles.monthTitle}>
              {data.label} {year}
            </h2>
            <ul className={styles.eventList}>
              {data.items
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((event, index) => (
                  <li className={styles.eventListItem} key={index}>
                    <a
                      className={styles.event}
                      href={createInternalHref({
                        href: event.slug?.current,
                        locale,
                        type: event._type,
                      })}
                    >
                      <h3 className={styles.eventTitle}>{event.title}</h3>
                      <ul className={styles.eventMeta}>
                        <li className={styles.eventMetaItem}>
                          {new Date(event.date).toLocaleString("en-US", {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          })}
                        </li>
                        {event.location && (
                          <li className={styles.eventMetaItem}>
                            {event.location}
                          </li>
                        )}
                      </ul>
                      <p className={styles.eventIntro}>{event.intro}</p>
                      <div className={styles.eventImage}>
                        <EventLabel
                          startDate={
                            event.date && formatDatePreview(event.date, locale)
                          }
                          endDate={
                            event.endDate &&
                            formatDatePreview(event.endDate, locale)
                          }
                        />
                        <SrcSet
                          alt=""
                          src={event.overviewImage || event.heroImage?.url}
                          sizes={[
                            {
                              minWidth: 1024,
                              width: 300,
                              ratio: 16 / 9,
                            },
                            { minWidth: 900, width: 300, ratio: 16 / 9 },
                            { minWidth: 768, width: 265, ratio: 16 / 9 },
                            { minWidth: 500, width: 80, ratio: 1 / 1 },
                            { minWidth: 1, width: 64, ratio: 1 / 1 },
                          ]}
                        />
                      </div>
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
};
